"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderPopupImage = void 0;
var React = require("react");
var app_1 = require("app");
var dialog_1 = require("../../../Partials/Components/ModalDialog/dialog");
var GalleryImageWrapper_1 = require("../../../Partials/Components/Gallery/components/GalleryImageWrapper");
var PopupImage = function (_a) {
    var mediaItem = _a.mediaItem;
    var _b = React.useState(true), isPopupOpened = _b[0], setIsPopupOpened = _b[1];
    React.useEffect(function () {
        setIsPopupOpened(true);
    }, [mediaItem]);
    var closeDialogHandler = function () {
        setIsPopupOpened(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(dialog_1.Dialog, { onClose: closeDialogHandler, title: "", isOpen: isPopupOpened, classes: "desktop-modal-gallery" },
            React.createElement(GalleryImageWrapper_1.default, { mediaItem: mediaItem, isMainImage: true, itemKey: mediaItem.imageHeight }))));
};
exports.default = PopupImage;
function renderPopupImage(mediaItem, element) {
    app_1.reactDOMRender(React.createElement(PopupImage, { mediaItem: mediaItem }), element);
}
exports.renderPopupImage = renderPopupImage;
